import { SortDirection } from '../../../core/components/DataTableHeaders';

/**
 * Updates a reclamation in local state with optimistic updates
 * @param {Function} setState - Component setState function
 * @param {number|string} id - Reclamation ID
 * @param {Object} patch - Fields to update
 */
export function updateLocalReclamation(setState, id, patch) {
  const applyPatch = (rec) => {
    if (rec.id !== id) return rec;
    const next = { ...rec, ...patch };
    if (rec.vehicleDetails || patch.vehicleDetails) {
      next.vehicleDetails = { ...rec.vehicleDetails, ...patch.vehicleDetails };
    }
    return next;
  };

  setState((prev) => {
    const nextLocal = (prev.localReclamations || []).map(applyPatch);
    const nextSearch = prev.searchResults ? prev.searchResults.map(applyPatch) : null;
    return {
      ...prev,
      localReclamations: nextLocal,
      searchResults: nextSearch,
    };
  });
}

/**
 * Handles cell commit events for inline editing
 * @param {Object} payload - Cell commit payload
 * @param {Function} handleInlineFieldSave - Handler for field saves
 */
export function handleCellCommit(payload, handleInlineFieldSave) {
  const { row, keyName, value, mode } = payload;
  const id = row?._id || row?.id;
  if (!id || !keyName) return;
  if (mode !== 'commit') return;

  switch (keyName) {
    case 'vehicle':
      handleInlineFieldSave(id, 'vehicle', value);
      break;
    case 'customerName':
      handleInlineFieldSave(id, 'customerName', value);
      break;
    case 'customerPhone':
      handleInlineFieldSave(id, 'customerPhone', value);
      break;
    case 'customerEmail':
      handleInlineFieldSave(id, 'customerEmail', value);
      break;
    default:
      break;
  }
}

/**
 * Handles sort column changes
 * @param {Function} setState - Component setState function
 * @param {Object} currentSortQuery - Current sort query state
 * @param {string} keyName - Column key name to sort by
 */
export function handleSort(setState, currentSortQuery, keyName) {
  if (!keyName) return;
  const prev = currentSortQuery || {};
  const nextDirection = prev.key === keyName ? !prev.direction : SortDirection.ASC;
  setState({
    sortQuery: { key: keyName, direction: nextDirection },
  });
}
